import React from 'react';
import { Search } from 'lucide-react';
import { TextField } from '@radix-ui/themes';

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
    value,
    onChange,
    placeholder = "Search...",
    className = "",
    disabled = false
}) => {
    return (
        <div className={`relative ${className}`}>
            <TextField.Root
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                placeholder={placeholder}
                className="w-full"
            >
                <TextField.Slot>
                    <Search height="16" width="16" />
                </TextField.Slot>
            </TextField.Root>
        </div>
    );
};

export default SearchBar;
